import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';

const modules = [
  { key: 'hardware', label: 'Hardware', path: '/reporting-hub/hardware', enabled: true },
  { key: 'software', label: 'Software', path: '/reporting-hub/software', enabled: true },
  { key: 'certification', label: 'Certification', path: '/reporting-hub/certification', enabled: true },
];

const ReportingHubHome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white p-5">
      <div className="w-full mx-auto">
        <div className="flex items-center gap-3 sm:mb-10 mb-5">
          <button
            onClick={() => navigate('/dashboard')}
            className="p-2 rounded-full hover:bg-gray-800 transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="sm:w-7 sm:h-7 w-6 h-6" />
          </button>
          {/* <h1 className="text-2xl font-bold">Project Reporting Hub</h1> */}
          <h1 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl font-bold break-words">
          Project Reporting Hub
          </h1>
        </div>

        <div className="space-y-4">
          {modules.map((m) => (
            <button
              key={m.key}
              onClick={() => m.enabled && navigate(m.path)}
              disabled={!m.enabled}
              className={`w-full flex items-center justify-between px-13 py-3 text-left transition-colors ${
                m.enabled
                  ? '  hover:bg-gray-800 cursor-pointer'
                  : '  text-gray-500 cursor-not-allowed'
              }`}
            >
              <span className="text-xl font-medium">{m.label}</span>
              <span className="flex items-center gap-2 text-sm">
                {!m.enabled && <span className="text-xs text-gray-600">Coming soon</span>}
                <ChevronRight className="w-6 h-6" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportingHubHome;
